export enum EmployeeGender {
  MALE = 'male',
  FEMALE = 'female',
}

export const EMPLOYEE_GENDER_VALUES = Object.values(EmployeeGender);
